// Panel dédié Kimi Code — pattern network (1 fichier fin par CLI).
import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { CliPanel } from "./cli/cli-panel";

const KimiCliPanel: Component = () => <CliPanel cli="kimi" />;

registerPanel("cli-kimi", KimiCliPanel);
export default KimiCliPanel;
